import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { AlertTriangle, ImageOff } from "lucide-react";

export default function LowStock() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard/stats").then((r) => setStats(r.data)); }, []);

  const out = stats?.out_size_alerts || [];
  const low = stats?.low_size_alerts || [];
  const empty = !stats || (out.length === 0 && low.length === 0);

  return (
    <div className="p-4 sm:p-6 lg:p-10" data-testid="low-stock-page">
      <header className="mb-8">
        <div className="font-mono-ds text-[10px] tracking-widest uppercase text-zinc-500 mb-2">/ ALERTS · BY SIZE VARIANT</div>
        <h1 className="section-title text-5xl lg:text-6xl flex items-center gap-4">
          Low Stock <AlertTriangle size={48} className="text-[#FF3333]" strokeWidth={2.5} />
        </h1>
        <p className="text-zinc-600 mt-3 text-sm max-w-xl">Each size variant compared to its own threshold. Restock anything below before the next drop.</p>
      </header>

      {empty ? (
        <div className="brut-card p-12 text-center bg-[#00C853]" data-testid="low-stock-empty">
          <h3 className="font-display font-black text-3xl">All Clear.</h3>
          <p className="font-mono-ds text-xs tracking-widest uppercase mt-2">Nothing below threshold.</p>
        </div>
      ) : (
        <div className="space-y-8">
          {out.length > 0 && <SizeTable title={`Out of Stock — ${out.length} variants`} items={out} variant="alert" />}
          {low.length > 0 && <SizeTable title={`Low Stock — ${low.length} variants`} items={low} variant="warning" />}
        </div>
      )}
    </div>
  );
}

function SizeTable({ title, items, variant }) {
  return (
    <div className="brut-card overflow-hidden">
      <div className={`px-5 py-3 border-b-2 border-black flex items-center justify-between ${variant === "alert" ? "bg-[#FF3333] text-white" : "bg-[#FFB800]"}`}>
        <h2 className="font-display font-black text-xl tracking-tight uppercase">{title}</h2>
      </div>
      <table className="brut-table">
        <thead><tr><th>Image</th><th>Product</th><th>SKU</th><th>Size</th><th>Stock</th><th>Threshold</th><th>Short By</th><th></th></tr></thead>
        <tbody>
          {items.map((it, i) => (
            <tr key={`${it.product_id}-${it.size}-${i}`} data-testid={`low-stock-row-${it.product_sku}-${it.size}`}>
              <td className="w-16">
                <div className="w-12 h-12 border-2 border-black bg-zinc-100 overflow-hidden">
                  {it.image ? <img src={fileUrl(it.image)} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-zinc-400"><ImageOff size={16} /></div>}
                </div>
              </td>
              <td className="font-display font-bold">{it.product_name}</td>
              <td className="font-mono-ds text-xs">{it.product_sku}</td>
              <td><span className="brut-badge">{it.size}</span></td>
              <td className="font-mono-ds font-bold text-lg">{it.stock}</td>
              <td className="font-mono-ds">{it.threshold}</td>
              <td className="font-mono-ds font-bold text-[#FF3333]">{it.shortfall || "—"}</td>
              <td><Link to={`/products/${it.product_id}`} className="brut-btn-outline px-3 py-1.5 text-xs inline-block">Restock →</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
